import React from 'react';
import { motion } from 'framer-motion';

export const ProblemSection = () => {
  return (
    <section 
      data-testid="problem-section"
      className="section-padding px-8 md:px-12 bg-white"
    >
      <div className="max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          {/* Section Label with accent */}
          <div className="flex items-center gap-4 mb-8">
            <div className="w-12 h-[2px] bg-amber-600" />
            <p className="font-sans text-xs tracking-widest uppercase text-gray-400">
              Sound Familiar?
            </p>
          </div>

          {/* Editorial Quote Style - Bold */}
          <h2 className="font-editorial text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-10">
            The Problem Is Not the Market.{' '}
            <span className="text-amber-600">It Is Investing Without a System.</span>
          </h2>

          {/* Body */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="font-sans text-lg text-gray-600 leading-relaxed space-y-6"
          >
            <p>
              The average investor does not underperform because they lack intelligence or access to information. They underperform because, without a structured framework behind their decisions, every market movement becomes an emotional event.
            </p>
            
            <p>
              Markets drop. They sell. Markets surge. They chase. Things feel uncertain. They freeze. Then they look back and wonder why their portfolio does not reflect the effort they put in.
            </p>
            
            <p>
              This is not a discipline problem. It is a system problem. And no financial advisor, stock newsletter, or cable news segment was designed to fix it. They were designed to generate fees, sell subscriptions, and fill airtime.
            </p>

            <p>
              If you have ever made an investment decision and immediately second-guessed it, or held a position longer than you should have because you did not know when to step back, or sold something in a panic only to watch it recover three weeks later, you already understand the problem better than any market research study can describe.
            </p>
            
            <p className="font-semibold text-gray-900 border-l-4 border-amber-600 pl-6 py-2">
              The question is whether you are ready to replace that pattern with something that actually works.
            </p>
          </motion.div>

          {/* CTA */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.5 }}
            className="mt-12"
          >
            <button
              onClick={() => { const el = document.getElementById('mechanism-section'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }}
              data-testid="problem-section-cta"
              className="group flex items-center gap-2 font-sans text-sm text-amber-600 hover:text-amber-700 font-medium transition-colors"
            >
              <span>See How Charles's Framework Solves This</span>
              <svg className="w-4 h-4 group-hover:translate-y-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
            </button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
